import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
  Button,
} from '@predoc/cow';
import { REQUEST_METHOD_CONFIG, Suggestion } from './constants';
import { ExternalLink } from 'lucide-react';

interface RecommendationsAccordionProps {
  methodsPresent: string[];
}

export const RecommendationsAccordion = ({
  methodsPresent,
}: RecommendationsAccordionProps) => {
  const allMethodKeys = Object.keys(REQUEST_METHOD_CONFIG) as Array<
    keyof typeof REQUEST_METHOD_CONFIG
  >;
  const missing = allMethodKeys.filter((key) => !methodsPresent.includes(key));

  const methodToSuggestion = (
    key: keyof typeof REQUEST_METHOD_CONFIG,
  ): Suggestion => {
    const cfg = REQUEST_METHOD_CONFIG[key];
    return {
      key,
      title: cfg.title,
      description: cfg.description,
      Icon: cfg.icon,
    };
  };

  const suggestions: Suggestion[] = missing.map((k) => methodToSuggestion(k));

  return (
    <Accordion
      type="single"
      collapsible
      className="bg-accent/90 rounded-lg border"
    >
      <AccordionItem value="recommendations" className="border-none">
        <AccordionTrigger className="text-muted-foreground font- px-4 py-3 font-light hover:no-underline">
          See what other products and services can amplify your workflow
        </AccordionTrigger>
        <AccordionContent className="mt-4 px-6 pb-6">
          <div className="space-y-4">
            {suggestions.map(({ key, title, description, Icon }) => (
              <div key={key} className="flex items-start gap-3">
                <Icon className="text-muted-foreground h-6 w-6 scale-110 transform" />
                <div>
                  <div className="text-sm font-medium">{title}</div>
                  <div className="text-muted-foreground text-sm">
                    {description}
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="mt-6">
            <Button
              onClick={() =>
                window.open(
                  'https://www.predoc.ai',
                  '_blank',
                  'noopener,noreferrer',
                )
              }
            >
              Learn More
              <ExternalLink className="ml-2 h-4 w-4" />
            </Button>
          </div>
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
};
